<template>
  <div class="input-group">
    <label>{{ label }}
      <input class="form-input" @input="sendValue" :value="value" v-bind="$attrs">
    </label>
    <small v-if="help" class="help-text">{{ help }}</small>
    <div v-if="errors.length" class="field-errors">
      <div v-for="error in errors" :key="error"> &times; {{ error }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseInput',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    help: {
      type: String,
      default: ''
    },
    errors: {
      type: Array,
      default: Array
    }
  },
  methods: {
    sendValue (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

.input-group {
  margin-bottom: 10px;
}

.field-errors {
  margin-top: 3px;
  font-size: 13px;
  color: $error;
}

.help-text {
  font-size: 13px;
  color: $text-secondary;
}

</style>
